export const ProductRequireModel = [
  {
    formName: 'formProductInsurancePlan',
    fieldRequired: [
      'productCode',
      'businessProgramCode',
      'exploitingType',
      'exploitingCode',
      'curencyMoney',
      'curencyFee',
      'exchangeRate',
      'calculationType',
    ],
  },
  //hang
  {
    formName: 'formCargoInsuranceOfferFee',
    fieldRequired: [
      'packageCode',
      'packageName',
      'valuationBasis',
      'commodityGroup',
      'commodityType',
      'commodityName',
      'tripNumber',
      'transShipment',
      'shippingType',
      'packingType',
      'unit',
      '_sellingContractCargoPackageBenefits',
      '_sellingContractCargoPackageExtensions',
    ],
  },
  {
    formName: 'formCargoListInsured',
    fieldRequired: ['price', 'weightOrQuantity'],
  },
  // tau
  {
    formName: 'formMarineInsuranceOfferFee',
    fieldRequired: [
      'packageCode',
      'name',
      'shipOwer',
      'shipGroup',
      'shipType',
      'manufacturingYear',
      'seat',
      'startDate',
      'shippingType',
      'expireDate',
      'price',
      'amountShip',
      '_sellingContractMarinePackageBenefitDtos',
      '_sellingContractMarinePackageExtensionDtos',
      '_sellingContractMarinePackageDeductibleDtos',
    ],
  },
  // hon hop
  {
    formName: 'formMicroInsuranceOfferFee',
    fieldRequired: [
      'name',
      'startDate',
      'expireDate',
      'address',
      'indentifyNumber',
      'nameInsured',
      'addressInsured',
      'sellingContractMicroBenefitPackage',
      'sellingContractMicroExtensionPackage',
      'sellingContractMicroDeductiblePackage',
    ],
  },
  {
    formName: 'formMarineListInsured',
    fieldRequired: ['price', 'weightOrQuantity'],
  },
  {
    formName: 'formProductContract',
    fieldRequired: ['contractType', 'purchaseDate', 'manager'],
  },
]
